import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { SectionTitle } from "./SectionTitle";
import { ReviewCard } from "./ReviewCard";
import { GoogleRating } from "./GoogleRating";

export const ReviewsCarousel = () => {
  const { reviews } = useSite();
  const track = useRef(null);
  const [paused, setPaused] = useState(false);

  const step = useCallback((dir) => {
    const el = track.current;
    if (!el) return;
    const card = el.firstElementChild;
    const w = card ? card.getBoundingClientRect().width + 20 : el.clientWidth;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 8;
    if (dir > 0 && atEnd) el.scrollTo({ left: 0, behavior: "smooth" });
    else el.scrollBy({ left: dir * w, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (paused || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const t = setInterval(() => step(1), 6500);
    return () => clearInterval(t);
  }, [paused, step]);

  if (!reviews.length) return null;
  const arrow = "hidden h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-emerald-900 transition-colors hover:bg-emerald-950 hover:text-gold-light md:flex";
  return (
    <section className="container-lux py-20 lg:py-28" data-testid="reviews-section">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <SectionTitle eyebrow="Yorumlar" title="Misafir Yorumları" sub="Lunessa’yı ziyaret eden misafirlerimizin deneyimlerinden bazıları." />
        <div className="mb-10 flex items-center gap-2 lg:mb-14">
          <button type="button" className={arrow} onClick={() => step(-1)} aria-label="Önceki yorum" data-testid="reviews-prev"><ChevronLeft className="h-5 w-5" /></button>
          <button type="button" className={arrow} onClick={() => step(1)} aria-label="Sonraki yorum" data-testid="reviews-next"><ChevronRight className="h-5 w-5" /></button>
          <Link to="/yorumlar" className="btn-outline md:ml-1" data-testid="reviews-all-link">Tüm Yorumlar <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </div>
      <div className="mb-8">
        <GoogleRating testId="home-google-rating" />
      </div>
      <div
        ref={track}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onTouchStart={() => setPaused(true)}
        className="-mx-5 flex snap-x snap-mandatory scroll-px-5 gap-5 overflow-x-auto scroll-smooth px-5 pb-4 [scrollbar-width:none] sm:-mx-8 sm:scroll-px-8 sm:px-8 lg:mx-0 lg:scroll-px-0 lg:px-0 [&::-webkit-scrollbar]:hidden"
        data-testid="reviews-track"
      >
        {reviews.slice(0, 12).map((r, i) => (
          <div key={r.id} className="w-[85%] shrink-0 snap-start sm:w-[calc(50%-10px)] lg:w-[calc(33.333%-14px)]">
            <ReviewCard r={r} testId={`review-slide-${i}`} />
          </div>
        ))}
      </div>
    </section>
  );
};
